import { render, staticRenderFns } from "./transferPage.vue?vue&type=template&id=cb8dd1b2&scoped=true&"
import script from "./transferPage.vue?vue&type=script&lang=js&"
export * from "./transferPage.vue?vue&type=script&lang=js&"
import style0 from "./transferPage.vue?vue&type=style&index=0&id=cb8dd1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8dd1b2",
  null
  
)

export default component.exports